function PageHeading({ subtitle, title, text, fixed, children }) {
    const lang = localStorage.getItem("i18nextLng") || "ar";
    const languageDir = lang;
    return (
        <div
            className={`page-heading ${!fixed ? languageDir : ""}`}
            style={{ display: "inline-block" }}
        >
            <div className="page-heading-text">
                {(subtitle || children) && (
                    <div
                        className={"flex items-center gap-5 w-full justify-between" + languageDir}
                        style={{
                            display: "flex",
                            gap: 8,
                        }}
                    >
                        {/* Red accent line */}
                        <span
                            style={{
                                display: "inline-block",
                                width: 28,
                                height: 3,
                                background: "#23cc4f",
                                borderRadius: 2,
                                flexShrink: 0,
                            }}
                        />
                        <p
                            style={{
                                fontSize: ".85rem",
                                fontWeight: 700,
                                color: "#23cc4f",
                                textTransform: "uppercase",
                                letterSpacing: "1px",
                                margin: 0,
                            }}
                        >
                            {subtitle}
                        </p>
                        {children}
                    </div>
                )}

                {/* <h3
                    dangerouslySetInnerHTML={{ __html: title }}
                    style={{
                        fontSize: "clamp(1.4rem, 3.5vw, 3rem)",
                        fontWeight: 800,
                        width: "fit-content",
                        color: "#1a1a1a",
                        lineHeight: 1.25,
                        margin: 0,
                    }}
                /> */}
            </div>

            {/* {text != null && (
                <div
                    style={{
                        fontSize: ".85rem",
                        color: "#6b7280",
                        marginTop: 10,
                        paddingInlineStart: 16,
                    }}
                >
                    {text}
                </div>
            )} */}
        </div>
    );
}

export default PageHeading;
